<template>
  <div class="waterfall-list">
    <waterfall :line-gap="210" :max-line-gap="250" :watch="list">
      <waterfall-slot
        v-for="(item, index) in list"
        :width="showWidth(item)"
        :height="showHeight(item) + paddingBottom(item)"
        :order="index"
        :key="item.id"
      >
        <div class=" waterfall-item">
          <div class="item-cont">
            <slot name="item" :item="item"/>
          </div>
          <div
            class=" item-text truncate"
          >{{ item.name }}</div>
        </div>
      </waterfall-slot>
    </waterfall>
    <div v-if="isEmpty" class=" waterfall-empty">
      <img :src="emptyImg" class="empty-img" width="200"/><br>
      <span class="empty-text" v-html='emptyText'></span>
    </div>
    <div v-if="!isEmpty && isFinished" class="waterfall-finished">{{ finishedText }}</div>
  </div>
</template>
<script>
import Waterfall from 'vue-waterfall/lib/waterfall'
import WaterfallSlot from 'vue-waterfall/lib/waterfall-slot'
export default {
  components: {
    Waterfall,
    WaterfallSlot
  },
  props: {
    upload: {
      type: Boolean,
      default: false
    },
    list: {
      type: Array,
      default () {
        return []
      }
    },
    bottom: {
      type: Number,
      default: 56
    },
    isEmpty: {
      type: Boolean,
      default: false
    },
    isFinished: {
      type: Boolean,
      default: false
    },
    emptyText: {
      type: String,
      default: '还没有相关模板'
    },
    finishedText: {
      type: String,
      default: '以上为所有搜索结果'
    },
    emptyImg: {
      type: String,
      default: require('/public/img/empty-help/list-empty.png')
    }
  },
  methods: {
    showWidth (item) {
      return item.width || 400
    },
    showHeight (item) {
      return item.height && item.width
        ? parseInt(item.height * 100 / item.width) > 210
          ? item.width * 2.1
          : parseInt(item.height * 100 / item.width) < 60
            ? item.width * 0.8
            : item.height
        : 400
    },
    paddingBottom (item) {
      return parseInt(item.height * 100 / item.width) > 210
        ? 0
        : parseInt(item.height * 100 / item.width) >= 60
          ? (2 * (item.height && item.width ? (parseInt(item.height * 100 / item.width) > 210 ? 16.8 : (item.height * 8 / item.width)) : 6))
          : -(2 * (item.height && item.width ? (parseInt(item.height * 100 / item.width) > 210 ? 16.8 : (item.height * 8 / item.width)) : 6))
    }
  }
}
</script>
<style lang="scss" scoped>
.waterfall-list {
  .waterfall-item {
    display: flex;
    flex-direction: column;
    position: relative;
    width: 100%;
    height: 100%;
    padding: 8px;
    .item-cont {
      flex: 1;
      height: 0;
    }
    .item-text {
      height: 32px;
      padding: 8px 0 0;
      font-size: 14px;
      text-align: left;
      color: #323337;
    }
  }
  .waterfall-empty {
    text-align: center;
    padding: 20px 0;
    .empty-img {
      display: inline-block;
    }
    .empty-text {
      font-size: 14px;
      color: #BCBDC0;
    }
  }
  .waterfall-finished {
    padding: 20px 0;
    font-size: 14px;
    // font-weight: 600;
    color: #BCBDC0;
    text-align: center;
  }
}
</style>